module.exports = __webpack_public_path__ + "static/media/anishc.a756ea49.jpeg";